{
  "R": [3, 64, 0, 0, 255, 255, 255],
  "G": [0, 0, 0, 255, 255, 192, 3],
  "B": [0, 32, 48, 56, 64, 96, 128],
  "A": [0, 8, 16, 24, 32, 52, 80],
  "I": [0, 32, 64, 96, 160, 192, 255]
}
